module.exports = __webpack_public_path__ + "img/6-2.05323216.png";